// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Vqiy","inner":"Form_inner__3aONh","range":"Form_range__sbkGo","name":"Form_name__3zXEv","actions":"Form_actions__1_xbG"};